export { default } from "./xmas-promo-banner";
